import { Fragment, ReactNode, RefObject } from "react"
import { Dialog, Transition } from "@headlessui/react"

interface Props {
  open: boolean
  onClose: () => void
  initialFocus: RefObject<HTMLElement>
  header: ReactNode
  children: ReactNode
}

// Full-screen search on phones. Headless UI gives us the portal, body scroll
// lock, focus trap and Escape handling; we only lay out the two regions.
const MobileSearchSheet = ({
  open,
  onClose,
  initialFocus,
  header,
  children
}: Props) => (
  <Transition.Root show={open} as={Fragment}>
    <Dialog
      as="div"
      className="relative z-50"
      aria-label="Search"
      onClose={onClose}
      initialFocus={initialFocus}
    >
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-200 motion-reduce:transition-none"
        enterFrom="opacity-0 translate-y-2"
        enterTo="opacity-100 translate-y-0"
        leave="ease-in duration-150 motion-reduce:transition-none"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-2"
      >
        {/* h-[100dvh] tracks the visible viewport where supported; inset-0 is the fallback */}
        <Dialog.Panel className="fixed inset-0 flex h-[100dvh] transform-gpu flex-col bg-white">
          <div className="shrink-0 border-b border-neutral-200 px-3 pb-2 pt-[calc(env(safe-area-inset-top,0px)+0.5rem)]">
            {header}
          </div>
          <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain pb-[env(safe-area-inset-bottom,0px)]">
            {children}
          </div>
        </Dialog.Panel>
      </Transition.Child>
    </Dialog>
  </Transition.Root>
)

export default MobileSearchSheet
